<div class="container mx-auto px-4">
  <!-- Section Activités récentes -->
  <!-- En-tête Documents avec actions -->
  <!-- En-tête Documents avec actions (Aligné sur Lots) -->
  <div class="bg-white rounded-xl shadow-sm p-5 mb-6">
    <div class="flex flex-col sm:flex-row gap-4 items-center justify-between">

      <!-- Barre de recherche -->
      <div class="relative w-full sm:w-72">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <input type="text" [(ngModel)]="searchQuery" [placeholder]="t('documents.search')" class="w-full h-11 pl-10 pr-4 border border-gray-300 rounded-lg
               focus:ring-2 focus:ring-orange-500 focus:border-orange-500
               outline-none transition text-sm bg-white">
      </div>

      <!-- Actions Droite: Filtre & Bouton -->
      <div class="flex gap-3 w-full sm:w-auto">
        <!-- Filtre par Type -->
        <!-- <div class="relative w-full sm:w-48">
          <select [(ngModel)]="selectedTypeFilter" (change)="onTypeFilterChange()" class="w-full h-11 px-4 pr-10 bg-white border border-gray-300 rounded-lg
                 text-sm text-gray-600 appearance-none cursor-pointer
                 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500">
            <option value="0">{{ t('documents.allTypes') }}</option>
            <option *ngFor="let type of documentTypes" [value]="type.id">{{ type.label }}</option>
          </select>
          <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd" />
            </svg>
          </div>
        </div> -->

        <!-- Bouton Ajouter -->
        <button (click)="openAddDocumentModal()" class="h-11 px-6 bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-lg
               flex items-center gap-2 transition-colors whitespace-nowrap shadow-sm">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.85714 9.14286H1.14286C0.819051 9.14286 0.547813 9.03314 0.329147 8.81371
               C0.11048 8.59429 0.000765845 8.32305 0 8
               C-0.000757964 7.67695 0.108956 7.40571 0.329147 7.18629
               C0.549337 6.96686 0.820575 6.85714 1.14286 6.85714H6.85714V1.14286
               C6.85714 0.819051 6.96686 0.547813 7.18629 0.329147
               C7.40571 0.11048 7.67695 0.000765845 8 0
               C8.32305 -0.000757964 8.59467 0.108956 8.81486 0.329147
               C9.03505 0.549337 9.14438 0.820575 9.14286 1.14286V6.85714H14.8571
               C15.1809 6.85714 15.4526 6.96686 15.672 7.18629
               C15.8914 7.40571 16.0008 7.67695 16 8
               C15.9992 8.32305 15.8895 8.59467 15.6709 8.81486
               C15.4522 9.03505 15.1809 9.14438 14.8571 9.14286H9.14286V14.8571
               C9.14286 15.1809 9.03314 15.4526 8.81371 15.672
               C8.59429 15.8914 8.32305 16.0008 8 16
               C7.67695 15.9992 7.40571 15.8895 7.18629 15.6709
               C6.96686 15.4522 6.85714 15.1809 6.85714 14.8571V9.14286Z" fill="white" />
          </svg>
          <span class="hidden sm:inline">{{ t('documents.newDocument') }}</span>
        </button>
      </div>
    </div>
  </div>

  <h2 class="text-2xl font-bold text-gray-800">{{ t('documents.recentActivities') }}</h2>
  <!-- Cartes de documents récents -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
    <div *ngFor="let doc of recentActivities" class="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
      <div class="p-4">
        <!-- Thumbnail conditionnel : PDF icon ou image -->
        <div class="w-full h-36 bg-gray-100 mb-4 flex items-center justify-center rounded-lg overflow-hidden">
          <!-- Si c'est un PDF, afficher l'icône PDF -->
          <app-pdf-icon *ngIf="isPDF(doc.thumbnail)" [width]="300" [height]="144" [iconSize]="56" [filename]="doc.name"
            [showLabel]="false">
          </app-pdf-icon>

          <!-- Si c'est une image ou autre, afficher la miniature -->
          <img *ngIf="!isPDF(doc.thumbnail)" [src]="doc.thumbnail" alt="Aperçu du document"
            class="w-full h-full object-cover">
        </div>

        <div class="flex justify-between items-start">
          <div class="flex items-start">
            <span class="text-gray-500 mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </span>
            <span class="font-medium">{{ doc.name }}</span>
          </div>
          <button class="text-gray-400 hover:text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>



  <!-- Liste des documents -->
  <div class="bg-white rounded-lg shadow overflow-hidden">
    <!-- En-tête du tableau -->
    <div
      class="grid grid-cols-12 gap-4 px-6 py-3 bg-gray-50 border-b text-xs font-semibold text-gray-600 uppercase tracking-wider">
      <div class="col-span-1">
        <input type="checkbox" class="rounded border-gray-300">
      </div>
      <div class="col-span-3">{{ t('documents.name') }}</div>
      <div class="col-span-2">{{ t('documents.type') }}</div>
      <div class="col-span-2">{{ t('documents.date') }}</div>
      <div class="col-span-3">{{ t('documents.lastModified') }}</div>
      <div class="col-span-1">{{ t('common.actions') }}</div>
    </div>

    <!-- État de chargement -->
    <div *ngIf="isLoading" class="py-16 text-center">
      <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      <p class="mt-4 text-gray-500">{{ t('common.loading') }}</p>
    </div>

    <!-- Liste vide -->
    <div *ngIf="!isLoading && documents.length === 0" class="py-16 text-center">
      <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
      <p class="mt-4 text-gray-500 font-medium">{{ t('documents.noDocuments') }}</p>
    </div>

    <!-- Liste des documents -->
    <div *ngFor="let doc of documents"
      class="grid grid-cols-12 gap-4 px-6 py-4 border-b last:border-b-0 hover:bg-gray-50 transition-colors items-center group">
      <!-- Checkbox -->
      <div class="col-span-1 flex items-center">
        <input type="checkbox" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
      </div>

      <!-- Nom et description -->
      <div class="col-span-3 flex items-center gap-3">
        <div class="min-w-0 flex-1">
          <a [href]="getFileUrl(doc.file)" target="_blank"
            class="text-gray-900 hover:text-blue-600 font-medium text-sm transition-colors block truncate">
            {{ doc.title }}
          </a>
          <p class="text-xs text-gray-500 mt-0.5 truncate">{{ doc.description }}</p>
        </div>
      </div>

      <!-- Type -->
      <div class="col-span-2">
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
          {{ doc.type?.label || '—' }}
        </span>
      </div>

      <!-- Date début -->
      <div class="col-span-2 text-sm text-gray-600">
        {{ doc.startDate ? formatDate(doc.startDate) : '—' }}
      </div>

      <!-- Dernière modification -->
      <div class="col-span-3 text-sm text-gray-600">
        {{ doc.endDate ? formatDate(doc.endDate) : '—' }}
      </div>

      <!-- Action -->
      <div class="col-span-1 flex items-center gap-2">
        <!-- Bouton télécharger -->
        <button (click)="downloadDocument(doc)" class="p-2 text-gray-400 hover:text-blue-600 transition-colors"
          title="Télécharger">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
        </button>

        <!-- Bouton supprimer -->
        <button (click)="openDeleteConfirmModal(doc.id)" class="p-2  hover:text-red-600 transition-colors"
          title="Supprimer">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Pagination Controls améliorée -->
  <div *ngIf="!isLoading && documents.length > 0"
    class="mt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
    <!-- Page info -->
    <div class="text-sm text-gray-600">
      {{ t('projects.showing') }} {{ (currentPage * pageSize) + 1 }} - {{ Math.min((currentPage + 1) * pageSize,
      totalElements) }}
      {{ t('projects.on') }} {{ totalElements }} {{ t('documents.documents') }}
    </div>

    <!-- Navigation -->
    <div class="flex items-center gap-2">
      <!-- First page -->
      <button (click)="goToPage(0)" [disabled]="currentPage === 0"
        class="px-2 py-1.5 border border-gray-300 rounded-lg text-sm disabled:opacity-30 hover:bg-gray-100 transition-colors"
        title="Première page">
        «
      </button>

      <!-- Previous button -->
      <button (click)="previousPage()" [disabled]="currentPage === 0"
        class="px-3 py-1.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-sm">
        {{ t('common.previous') }}
      </button>

      <!-- Page numbers -->
      <div class="flex items-center gap-1">
        <button *ngFor="let page of getDocPageNumbers()" (click)="goToPage(page)" [ngClass]="page === currentPage ? 
            'bg-orange-500 text-white border-orange-500' : 
            'border-gray-300 text-gray-600 hover:bg-gray-100'"
          class="px-3 py-1.5 border rounded-lg text-sm min-w-[2rem] transition-colors">
          {{ page + 1 }}
        </button>
      </div>

      <!-- Next button -->
      <button (click)="nextPage()" [disabled]="currentPage >= totalPages - 1"
        class="px-3 py-1.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-sm">
        {{ t('common.next') }}
      </button>

      <!-- Last page -->
      <button (click)="goToPage(totalPages - 1)" [disabled]="currentPage >= totalPages - 1"
        class="px-2 py-1.5 border border-gray-300 rounded-lg text-sm disabled:opacity-30 hover:bg-gray-100 transition-colors"
        title="Dernière page">
        »
      </button>

      <!-- Direct page input -->
      <div class="flex items-center gap-1 ml-2">
        <span class="text-sm text-gray-500">Aller à</span>
        <input type="number" [value]="currentPage + 1" (change)="goToPageInput($event)" min="1" [max]="totalPages"
          class="w-14 px-2 py-1.5 border border-gray-300 rounded-lg text-sm text-center focus:ring-2 focus:ring-orange-500 focus:border-transparent">
      </div>
    </div>

    <!-- Page size selector -->
    <div class="flex items-center gap-2">
      <span class="text-sm text-gray-600">{{ t('projects.perPage') }}</span>
      <select (change)="onPageSizeChange($event)" [value]="pageSize"
        class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm">
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
      </select>
    </div>
  </div>

  <!-- Modal Ajout (conservé mais simplifié) -->
  <div *ngIf="showAddDocumentModal"
    class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4"
    (click)="closeTypeDropdown()">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto"
      (click)="$event.stopPropagation()">
      <div class="p-6 border-b">
        <h3 class="text-xl font-semibold text-gray-900">{{ t('documents.newDocument') }}</h3>
      </div>

      <div class="p-6 space-y-6">
        <!-- Titre -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('documents.titleLabel') }} *</label>
          <input [(ngModel)]="newDocument.title" type="text" required
            class="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500">
        </div>

        <!-- Type de document avec dropdown personnalisé -->
        <div class="relative">
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('documents.typeLabel') }} *</label>

          <!-- Bouton de sélection -->
          <button type="button" (click)="toggleTypeDropdown()"
            class="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-left flex items-center justify-between">
            <span [class.text-gray-400]="!newDocument.typeId || newDocument.typeId === 0">{{ getSelectedTypeName()
              }}</span>
            <svg class="w-5 h-5 text-gray-400 transition-transform" [class.rotate-180]="showTypeDropdown" fill="none"
              stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <!-- Dropdown -->
          <div *ngIf="showTypeDropdown"
            class="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">

            <!-- Champ de recherche -->
            <div class="p-2 border-b border-gray-200">
              <input type="text" [(ngModel)]="typeSearchQuery" placeholder="Rechercher un type..."
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm"
                (click)="$event.stopPropagation()">
            </div>

            <!-- Liste des types (max 4 visibles avec scroll) -->
            <div class="max-h-[200px] overflow-y-auto">
              <button type="button" *ngFor="let type of getFilteredDocumentTypes()" (click)="selectDocumentType(type)"
                class="w-full px-4 py-2.5 text-left hover:bg-orange-50 transition-colors flex items-center justify-between group"
                [class.bg-orange-100]="newDocument.typeId === type.id">
                <span class="text-sm" [class.font-semibold]="newDocument.typeId === type.id">{{ type.label }}</span>
                <svg *ngIf="newDocument.typeId === type.id" class="w-5 h-5 text-orange-600" fill="currentColor"
                  viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd" />
                </svg>
              </button>

              <!-- Message si aucun résultat -->
              <div *ngIf="getFilteredDocumentTypes().length === 0" class="px-4 py-3 text-sm text-gray-500 text-center">
                Aucun type trouvé
              </div>
            </div>
          </div>
        </div>

        <!-- Fichier -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('documents.fileLabel') }} *</label>
          <div class="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
            <input type="file" id="fileInput" class="hidden" (change)="onFileSelected($event)"
              accept=".pdf,.doc,.docx,.jpg,.png,.xls,.xlsx">

            <div *ngIf="!selectedFile" (click)="triggerFileInput()" class="cursor-pointer">
              <svg class="mx-auto h-10 w-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
              <p class="mt-2 text-sm font-medium text-gray-600">{{ t('documents.clickToSelect') }}</p>
              <p class="text-xs text-gray-500 mt-1">{{ t('documents.fileFormats') }}</p>
            </div>

            <div *ngIf="selectedFile" class="text-center">
              <p class="font-medium text-green-600">{{ selectedFile.name }}</p>
              <p class="text-sm text-gray-500">{{ getFileSize(selectedFile) }}</p>
              <div class="mt-3 flex gap-3 justify-center">
                <button type="button" (click)="triggerFileInput()"
                  class="px-4 py-2 text-sm font-medium text-orange-600 bg-orange-50 rounded-lg hover:bg-orange-100 transition-colors">
                  {{ t('documents.change') }}
                </button>
                <button type="button" (click)="removeSelectedFile()"
                  class="px-4 py-2 text-sm font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition-colors">
                  {{ t('documents.remove') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Description -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('documents.descriptionLabel') }}</label>
          <textarea [(ngModel)]="newDocument.description" rows="4"
            class="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"></textarea>
        </div>

        <!-- Dates conditionnelles -->
        <div class="grid gap-4" [ngClass]="{
          'grid-cols-2': shouldShowStartDate() && shouldShowEndDate(),
          'grid-cols-1': shouldShowStartDate() !== shouldShowEndDate()
        }">
          <div *ngIf="shouldShowStartDate()">
            <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('documents.startDate') }}</label>
            <input type="date" [(ngModel)]="newDocument.startDate" required
              class="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500">
          </div>
          <div *ngIf="shouldShowEndDate()">
            <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('documents.endDate') }}</label>
            <input type="date" [(ngModel)]="newDocument.endDate" required
              class="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500">
          </div>
        </div>
      </div>

      <div class="px-6 py-4 bg-gray-50 border-t flex justify-end gap-3">
        <button type="button" (click)="closeAddDocumentModal()" [disabled]="isLoading"
          class="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          {{ t('common.cancel') }}
        </button>
        <button type="button" (click)="saveDocument()" [disabled]="isLoading || !isFormValid()"
          class="px-6 py-2.5 bg-orange-500 text-white font-medium rounded-lg hover:bg-orange-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
          <span *ngIf="isLoading"
            class="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
          <span *ngIf="!isLoading">{{ t('common.save') }}</span>
          <span *ngIf="isLoading">{{ t('common.processing') }}</span>
        </button>
      </div>
    </div>
  </div>
</div>



<!-- Modal de confirmation de suppression -->
<div *ngIf="showDeleteConfirmModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title"
  role="dialog" aria-modal="true">
  <!-- Overlay -->
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

  <!-- Modal content -->
  <div class="flex min-h-screen items-center justify-center p-4">
    <div class="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all sm:w-full sm:max-w-md">
      <div class="bg-white px-6 py-6">
        <div class="flex items-start gap-4">
          <!-- Icône -->
          <div class="flex-shrink-0">
            <div class="flex h-10 w-10 items-center justify-center rounded-full bg-red-50">
              <svg class="h-5 w-5 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
              </svg>
            </div>
          </div>

          <!-- Texte -->
          <div class="flex-1">
            <h3 class="text-base font-semibold text-gray-900 mb-1">
              Delete
            </h3>
            <p class="text-sm text-gray-600">
              Are you sure you want to delete this document?
            </p>
          </div>
        </div>
      </div>

      <!-- Boutons -->
      <div class="bg-gray-50 px-6 py-4 flex flex-row-reverse gap-3">
        <button type="button" (click)="confirmDelete()" [disabled]="isLoading"
          class="inline-flex justify-center rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          <span *ngIf="!isLoading">Confirm deletion</span>
          <span *ngIf="isLoading" class="flex items-center gap-2">
            <svg class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            Processing...
          </span>
        </button>

        <button type="button" (click)="closeDeleteConfirmModal()" [disabled]="isLoading"
          class="inline-flex justify-center rounded-md bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 border border-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>